<template>
  <div class="BaseSetPolygon">
    <div class="styleSetting">
      <div class="title">
        <span class="line"></span>
        <span>样式设置</span>
      </div>
      <div>
        <div class="form-item">
          <div class="label">宽度</div>
          <div class="slider">
            <span class="text" style="color: #ffffff;margin-right: 0.18rem">{{styleData.outlineWidth}}</span>
            <el-slider v-model="styleData.outlineWidth" :max="10" :show-tooltip="false" @change="onValueChange"></el-slider>
          </div>
        </div>
        <div class="form-item">
          <div class="label">轮廓颜色</div>
          <el-input v-model="styleData.outlineColor" placeholder="请输入内容" @change="onValueChange" disabled>
            <ColorPicker slot="suffix" v-model="styleData.outlineColor"  @changeColor="onValueChange"></ColorPicker>
          </el-input>
        </div>
        <div class="form-item">
          <div class="label">填充颜色</div>
          <el-input v-model="styleData.fillColor" placeholder="请输入内容" @change="onValueChange" disabled>
            <ColorPicker slot="suffix" v-model="styleData.fillColor" @changeColor="onValueChange"></ColorPicker>
          </el-input>
        </div>
        <div class="form-item">
          <div class="label">开启鼠标进入高亮</div>
          <el-switch
            v-model="styleData.isHover"
            active-color="#00A4F0"
            inactive-color="#494B4D"
            @change="onValueChange">
          </el-switch>
        </div>
      </div>
    </div>
    <div class="styleSetting">
      <div class="title">
        <span class="line"></span>
        <span>标签样式</span>
      </div>
      <div>
        <div class="form-item">
          <div class="label">标签字段</div>
          <el-select v-model="styleData.label" placeholder="请选择" :popper-append-to-body="false" @change="onLabelChange">
            <el-option
                    v-for="item in labelProperties"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="label">标签显示</div>
          <el-select v-model="styleData.showLabelType" placeholder="请选择" :disabled="styleData.label === 'empty'" :popper-append-to-body="false" @change="onValueChange">
            <el-option
                    v-for="item in labelShowOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="label">字体类型</div>
          <el-select v-model="styleData.labelStyle.labelFont" placeholder="请选择" :popper-append-to-body="false" @change="onValueChange">
            <el-option
                    v-for="item in fontFamilyList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="label">字体颜色</div>
          <el-input v-model="styleData.labelStyle.labelColor" placeholder="请选择" @change="onValueChange" disabled>
            <ColorPicker slot="suffix" v-model="styleData.labelStyle.labelColor"  @changeColor="onValueChange" :showAlpha="false"></ColorPicker>
          </el-input>
        </div>
        <div class="form-item">
          <div class="label">背景颜色</div>
          <el-input v-model="styleData.labelStyle.labelBackgroundColor" placeholder="请选择" @change="onValueChange" disabled>
            <ColorPicker slot="suffix" v-model="styleData.labelStyle.labelBackgroundColor" @changeColor="onValueChange"></ColorPicker>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/components/ColorPicker/ColorPicker'
export default {
  name: 'BaseSetPolygon',
  props: {},
  components: { ColorPicker },
  data () {
    return {
      // 样式属性
      styleData: {
        outlineWidth: undefined,
        fillColor: undefined,
        label: undefined,
        isHover: false,
        showLabelType: 'hide',
        labelStyle: {
          labelFont: undefined,
          labelColor: undefined,
          labelBackgroundColor: undefined
        }
      },
      properties: undefined,
      fontFamilyList: [{
        value: '宋体',
        label: '宋体'
      }, {
        value: '楷体',
        label: '楷体'
      }, {
        value: '黑体',
        label: '黑体'
      }],
      labelShowOptions: [{
        value: 'hide',
        label: '不显示'
      }, {
        value: 'show',
        label: '常显'
      }, {
        value: 'distance',
        label: '层级显示'
      }]
    }
  },
  computed: {
    // bindLabel: {
    //   get: function () {
    //     if (!this.styleData.label) {
    //       return undefined
    //     }
    //     return parseInt(this.styleData.label)
    //   },
    //   set: function (value) {
    //     this.styleData.label = value
    //   }
    // },
    labelProperties () {
      const properties = [{
        id: 'empty',
        name: '无'
      }, {
        id: 'markerName',
        name: '标注名称'
      }
      // , {
      //   id: 'index',
      //   name: '序号'
      // }
      ]
      if (this.properties) {
        for (let i = 0; i < this.properties.length; i++) {
          properties.push({
            id: this.properties[i].id.toString(),
            name: this.properties[i].name
          })
        }
      }
      return properties
    }
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {
    setData (styleData, data) {
      this.styleData = styleData
      this.properties = data.properties
    },
    changeColor (v) {
      console.log(v)
      this.$emit('layerStyleChanged', true)
    },
    // 属性值修改
    onValueChange () {
      this.$emit('layerStyleChanged', true)
    },
    onLabelChange () {
      if (this.styleData.label === 'empty') {
        this.styleData.showLabelType = 'hide'
      }
      this.$emit('layerStyleChanged', true)
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .BaseSetPolygon{
    text-align: left;
    .title{
      color: #FFFFFF;
      font-size: 14px;
      margin-bottom: 15px;
      >.line{
        display: inline-block;
        margin-right: 4px;
        width: 3px;
        height: 10px;
        background: #00A4F0;
        border-radius: 2px;
      }
    }
    .el-input .el-input__inner{
      font-size: 12px !important;
      height: 32px !important;
    }
    .el-input__prefix{
      display: flex;
      align-items: center;
      padding-left: 10px;
      >img{
        width: 15px;
        height: 15px;
      }
    }
    .el-radio-group{
      width: 155px;
      display: flex;
      .el-radio{
        margin-right: 16px;
        transform: scale(0.9);
      }
    }
    .baseInfo{
      border-bottom: 1px solid #424345;
      padding: 16px 12px;
      box-sizing: border-box;
      .form-item{
        margin-bottom: 16px;
        >.label{
          font-size: 12px;
          font-weight: 300;
          color: #999999;
          margin-bottom: 8px;
        }
      }
      .type{
        margin-bottom: 5px;
        .label{
          font-size: 13px;
          color: rgba(255, 255, 255, 0.3);
        }
        .value{
          font-size: 13px;
          color: #00A4F0;
        }
      }
    }
    .styleSetting{
      border-bottom: 1px solid #424345;
      padding: 16px 12px;
      box-sizing: border-box;
      .imgType{
        margin-bottom: 30px;
        >img{
          width: 60px;
          height: 60px;
          background: #373839;
          border-radius: 6px;
          margin-right: 26px;
          margin-bottom: 8px;
        }
      }
      .form-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        .label{
          width: 120px;
          font-size: 12px;
          color: #999999;
        }
        .slider{
          width: 230px;
          height: 32px;
          background: #424243;
          border-radius: 6px;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding: 0 12px;
          box-sizing: border-box;
          .el-slider{
            width: 100%;
            .el-slider__runway{
              height: 4px;
            }
            .el-slider__bar{
              height: 4px;
              background-color: $primary-color;
            }
            .el-slider__button{
              width: 8px;
              height: 8px;
              border: solid 0.02rem #ffffff;
              background-color: $primary-color;
              transform: translateY(-1px);
            }
          }
        }
      }
    }
  }
</style>
